import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom"
import { useSelector } from "react-redux";
import Menu from '@mui/material/Menu';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import Logout from '@mui/icons-material/Logout';
import ListItemIcon from '@mui/material/ListItemIcon';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import Divider from '@mui/material/Divider';
import useLogout from "../hooks/useLogout";
import { selectIsLoggedIn } from "../redux/authSlice";

const Header = () => {

    const logout = useLogout();

    const navigate = useNavigate();
    const location = useLocation();

    const isLoggedIn = useSelector(selectIsLoggedIn);

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    let backDestination;
    if (location.pathname.includes('insights')) {
        backDestination = "/insights";
    } else {
        backDestination = "/benchmarking";
    }

    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const signOut = async () => {
        await logout();
        navigate('/login');
        sessionStorage.removeItem("redirectAfterAuth");
        sessionStorage.removeItem("qualtricsSurveyId");
    }
    return (
        <header className="Header">
            <div className="header-group">
                <button className="home" onClick={() => navigate(backDestination)}></button>
                <h1>Advisor Insight</h1>
            </div>
            {
                isLoggedIn &&
                <div className="header-group" style={{ gap: '1rem' }} >
                    <button className="profile" onClick={handleClick}></button>
                </div>
            }
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
            >
                <MenuList dense>
                    <MenuItem onClick={() => navigate("/profile")}>
                        <ListItemIcon>
                            <AccountCircleIcon />
                        </ListItemIcon>
                        My Profile
                    </MenuItem>
                    <MenuItem onClick={() => navigate("/account")}>
                        <ListItemIcon>
                            <AlternateEmailIcon />
                        </ListItemIcon>
                        My Account
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={signOut}>
                        <ListItemIcon>
                            <Logout fontSize="small" />
                        </ListItemIcon>
                        Logout
                    </MenuItem>
                </MenuList>
            </Menu>
        </header>
    )
}

export default Header